// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutElements_container__CHTtY","content":"LayoutElements_content__6HOJK","skipLink":"LayoutElements_skipLink__nhkiW"};